import { render, staticRenderFns } from "./DashboardLastUpdateProject.vue?vue&type=template&id=5827045d&"
import script from "./DashboardLastUpdateProject.vue?vue&type=script&lang=js&"
export * from "./DashboardLastUpdateProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports